<template>
    <mdb-container fluid class="text-left">

        <h2>Faucet4all - User Agreement</h2>
        <h4>Last updated: March 03, 2019</h4>
        <p>
            Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the http://faucet4all.com website (the "Service") operated by Faucet4all ("us", "we", or "our").<br />
            Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.<br />
            By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.
        </p>
        <ol class="sections">
            <li>
                <h4>Accounts</h4>
                <ol class="terms">
                    <li>When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.</li>
                    <li>We store your password in an irreversible and up to date strongest encrypted format. In the unlikely event of someone hacking into your account, we will not be held responsible.</li>
                    <li>You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a third-party service.</li>
                    <li>You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.</li>
                    <li>You can only have one account. Any attempt to create more than one account will lead to the termination of all of them.</li>
                    <li>Your email addresses will not be shown, given or sold.</li>
                    <li>Accounts are not transferable.</li>
                    <li>You are limited to creating one account for yourself. Multiple accounts are not allowed. We reserve the right to immediately disable any accounts that are suspect of being created by the same person, though we will work with you to ensure you keep any amount of Bitcoins that you've legitimately earned.</li>
                </ol>
            </li>
            <li>
                <h4>No Automation, No Bypassing</h4>
                <ol class="terms">
                    <li>Faucet4all's entire model relies on you, the individual user, directly accessing and interacting with our Service.</li>
                    <li>Any attemps to circumvent this by automating any aspect including, but not limited to, tasks, games, or faucet spins will be considered a violation of these Terms and will result in immediate Termination and forfeiture of your account.</li>
                    <li>Similarly, any attempts to circumvent any restrictions of the offerwalls to which we link or the games we provide will be considered a violation of these Terms and will result in immediate Termination and forfeiture of your account.</li>
                </ol>
            </li>
            <li>
                <h4>No VPN / Proxy / Tor</h4>
                <ol class="terms">
                    <li>Faucet4all's Service requires that you access our website directly from your computer, specifically without use of a VPN, Tor, or any other service that would obscure your actual location from us and our partners. Violation of these Terms will result in immediate Termination and forfeiture of your account.</li>
                    <li>Reverse Engineering & Other Malicious Activity is strictly forbidden.</li>
                    <li>Any attempt to reverse engineer, cause harm or ortherwise interrupt or misuse the Cointiply website and/or services will result in account termination. Suspicious activity may be reported to the authorities at our discretion.</li>
                </ol>
            </li>
            <li>
                <h4>Advertisers</h4>
                <ol class="terms">
                    <li>By using Faucet4all you agree to receive advertising from numerous third party advertisers. Attempts to block or otherwise bypass the advertising will be considered a breach of these terms.</li>
                    <li>All adverts are approved manually.</li>
                    <li>Duration of adverts approval may last from 12 hours to 72 hours.</li>
                </ol>
            </li>
            <li>
                <h4>Links To Other Web Sites</h4>
                <ol class="terms">
                    <li>Our Service may contain links to third-party web sites or services that are not owned or controlled by Faucet4all.</li>
                    <li>Faucet4all has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that Faucet4all shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.</li>
                    <li>As an example, Faucet4all is not liable for OfferWall completions that do not credit you. However we shall assist you if your claims are correct.</li>
                    <li>We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that you visit.</li>
                </ol>
            </li>
            <li>
                <h4>Termination</h4>
                <ol class="terms">
                    <li>We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</li>
                    <li>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</li>
                    <li>Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.</li>
                    <li>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</li>
                </ol>
            </li>
            <li>
                <h4>Liability</h4>
                <ol class="terms">
                    <li>We will not be liable for any kind of delays or failures that are not directly related to Faucet4all and therefore beyond our control.</li>
                    <li>We will not be held responsible for any of our users, advertisers, advertisements or publishers. This also includes every supplier we depend on.</li>
                    <li>We are not responsible for any tax payment for you on what you receive from us. It's your responsibility to declare what you've received and pay your country's taxes.</li>
                </ol>
            </li>
            <li>
                <h4>Changes</h4>
                <ol class="terms">
                    <li>We reserve the right, at our sole discretion, to modify or replace these Terms at any time.</li>
                    <li>By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.</li>
                </ol>
            </li>
            <li>
                <h4>Contact Us</h4>
                <ol class="terms">
                    <li>If you have any questions about these Terms, please contact us using support channel provided at the top of our website.</li>
                </ol>
            </li>
        </ol>
    </mdb-container>
</template>

<script>
    import { mdbCol, mdbRow, mdbContainer, mdbBtn, mdbCard, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';

    export default {

        components: { mdbCol, mdbRow, mdbContainer, mdbBtn, mdbCard, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText },
        methods: {
            test: function () {



            },
            register: function () {

                this.$router.push('AccountRegister');
            }
        },
        data() {
            return {

            }
        },
        mounted() {

        }
    }
</script>